<template>
	<div class="accordion" :style="{ backgroundColor: backgroundColor }">
		<div class="accordion-header" @click="toggleAccordion">
			<h3>{{ label }}</h3>
			<span :class="isOpen ? 'arrow-up' : 'arrow-down'"></span>
		</div>
		<SlideTransition :is-visible="isOpen">
			<div class="accordion-content">
				<slot></slot>
			</div>
		</SlideTransition>
	</div>
</template>

<script setup lang="ts">
	import { ref, defineProps } from 'vue';
	import SlideTransition from '@/components/shared/SlideTransition.vue';

	const props = defineProps({
		isOpen: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			required: true
		},
		backgroundColor: {
			type: String,
			default: '#f2f3f5'
		},
		onExpand: {
			type: Function,
			default: () => {
				return;
			}
		},
		onClose: {
			type: Function,
			default: () => {
				return;
			}
		}
	});

	const isOpen = ref(props.isOpen);

	const toggleAccordion = () => {
		isOpen.value = !isOpen.value;
		isOpen.value ? props.onExpand() : props.onClose();
	};
</script>

<style scoped>
	.accordion {
		border-radius: 6px;
		margin-bottom: 12px;
	}

	.accordion-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px;
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
	}

	.accordion-content {
		padding: 0 12px 12px 12px;
	}

	.arrow-down::before,
	.arrow-up::before {
		content: '';
		display: inline-block;
		border: solid black;
		border-width: 0 2px 2px 0;
		padding: 3px;
		margin: 2px 0;
		transform-origin: center;
		transition: transform 0.3s ease;
	}

	.arrow-down::before {
		transform: rotate(45deg);
	}

	.arrow-up::before {
		transform: rotate(-135deg);
	}
</style>
